<template>
  <validation-observer ref="changeExchangeRateRef" #default="{ valid }">
    <b-modal
      ref="modal"
      title="Điều chỉnh chiết khấu"
      centered
      cancel-variant="outline-secondary"
      @ok.prevent="handleChangeDiscount"
      :ok-disabled="loading || !valid"
      @cancel="resetForm"
    >
      <b-row>
        <!-- Field: Password -->
        <b-col cols="8">
          <b-form-group label="Chiết khấu" label-for="exchangeRate">
            <validation-provider
              #default="{ errors }"
              name="discount"
              vid="discount"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  v-currency="config"
                  v-model="discount"
                  name="discount"
                  placeholder=""
                />
                <b-input-group-append is-text>%</b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{
                errors[0] && "Tỷ giá không hợp lệ."
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-cancel>
        <span>Từ chối</span>
      </template>
      <template #modal-ok>
        <Spinner v-if="loading" />
        <span v-else>Chấp nhận</span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { functionProp } from "@/helpers/props";
import useToastHandler from "@/services/toastHandler";
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  VBModal,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    VBModal,
    ValidationObserver,
    ValidationProvider,
    Spinner,
    BFormTextarea,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    handleUpdateInformation: functionProp(),
  },
  data() {
    return {
      discount: null,
    };
  },
  computed: {
    ...mapState({
      loading: (s) => s.apps.users.changeDiscount.loading,
    }),
    config() {
      return {
        currency: null,
        precision: { min: 0, max: 2 },
      };
    },
  },
  methods: {
    ...mapActions({
      changeDisCount: "users/changeDiscount/changeDiscount",
    }),
    async handleChangeDiscount() {
      const { userId } = this.$router.currentRoute.params;
      const discount = this.$parseCurrency(this.discount, {
        locale: "en",
        currency: null,
      });
      const res = await this.changeDisCount({
        userId: Number(userId),
        discount: Number(discount),
      });
      if (!res) return;

      /* Update user detail*/
      this.handleUpdateInformation({
        discount,
      });
      this.showToastSuccess(null, "Điều chỉnh chiết khấu  thành công.");
      this.resetForm();
    },
    handleShowModal() {
      this.$refs.modal.show();
    },
    resetForm() {
      this.discount = null;
      this.$refs.changeExchangeRateRef.reset();
      this.$refs.modal.hide();
    },
  },
  setup() {
    return {
      ...useToastHandler(),
    };
  },
};
</script>
